<template>
    <li class="jx2">
        <div class="inner">
            <div class="jx-imgbox" @mouseenter="showMask = true">
                <a href="course.html" target="_blank">
                    <pic :src="course.logoUrlNormal" class="m-img" />
                </a>
                <transition name="fade">
                    <div class="qg-info" v-show="showMask" @mouseleave="showMask = false">
                        <router-link
                            class="btn"
                            :to="{'name': 'course', 'params': {'id': course.id}}"
                            target="_blank"
                        >查看课程</router-link>
                    </div>
                </transition>
            </div>
            <div class="jx-imginfo">
                <div class="name">
                    <router-link
                        class="btn"
                        :to="{'name': 'course', 'params': {'id': course.id}}"
                        target="_blank"
                    >{{ course.name }}</router-link>
                </div>
                <div class="ename">
                    <a href target="_blank" style="float: left;">{{ course.teacher }}</a>
                    <span class="f-r">
                        <i class="edufont e-icon-ren"></i>
                        已有{{ course.count || '99+' }}人学习
                    </span>
                </div>
                <div class="price">
                    <span>
                        <font>¥</font>
                        {{ course.price || 0.00 }}
                    </span>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    name: 'course',
    props: ['course'],
    data() {
        let showCourse = ''
        return {
            showMask: false,
            showCourse: showCourse
        }
    },
    mounted() {}
}
</script>
<style scoped>
@import '../assets/css/common.css';
@import '../assets/css/index.css';

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/courseLi.vue